// @core/api/endpoints/workflow/get_execution.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  PipelineExecutionResponse,
} from '../../../types/workflow';

const BASE_PATH = '/workflow';

/**
 * Get execution
 * Retrieves a pipeline execution by ID, including all node execution statuses, inputs, outputs, and timing.
 */
export async function GetExecution(
  execution_id: string,
  options?: RequestOptions
): Promise<PipelineExecutionResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/workflows/executions/:execution_id`;
  requestPath = requestPath.replace(':execution_id', encodeURIComponent(execution_id));
  const requestOptions = options;
  return client.get<PipelineExecutionResponse>(requestPath, { ...requestOptions });
}
